import _extends from "@babel/runtime/helpers/esm/extends";
var colors = {
  base: {
    white: '#ffffff',
    black: '#000000'
  },
  primary: {
    darker: '#004736',
    dark: '#006B51',
    base: '#00B388',
    light: '#66D1B8',
    lighter: '#C9EDE4'
  },
  secondary: {
    // midnight
    darker: '#06090C',
    dark: '#090E13',
    base: '#101820',
    light: '#707479',
    lighter: '#CCCECF'
  },
  grey: {
    darker: '#595952',
    dark: '#86867C',
    base: '#D9D9D6',
    light: '#E8E8E6',
    lighter: '#F7F7F7'
  },
  green: {
    // duck
    darker: '#002B24',
    dark: '#004036',
    base: '#006C5B',
    light: '#66A79D',
    lighter: '#C9DFDB'
  },
  blue: {
    // neon
    darker: '#0D3260',
    dark: '#144B90',
    base: '#307FE2',
    light: '#83B2EE',
    lighter: '#D3E2F6'
  },
  yellow: {
    darker: '#8F6401',
    dark: '#D69702',
    base: '#FCBB26',
    light: '#FEE4A8',
    lighter: '#FCF3DF'
  },
  red: {
    // tomaro
    darker: '#7C1600',
    dark: '#BB2100',
    base: '#FF5C39',
    light: '#FF9D88',
    lighter: '#FCDBD4'
  },
  purple: {
    // grape
    darker: '#312A5B',
    dark: '#493F89',
    base: '#6254B6',
    light: '#AFA5EF',
    lighter: '#E4E1FA'
  },
  peach: {
    // 🤷‍♂️
    darker: '#A53500',
    dark: '#FF854C',
    base: '#FFBE9F',
    light: '#FFD8C5',
    lighter: '#FCEFE9'
  },
  ghost: {
    darker: 'rgba(255, 255, 255, 0.1)',
    dark: 'rgba(255, 255, 255, 0.2)',
    base: 'rgba(255, 255, 255, 0.4)',
    light: 'rgba(255, 255, 255, 0.6)',
    lighter: 'rgba(255, 255, 255, 0.8)'
  },
  darkGhost: {
    darker: 'rgba(217, 217, 214, 0.1)',
    dark: 'rgba(217, 217, 214, 0.2)',
    base: 'rgba(217, 217, 214, 0.4)',
    light: 'rgba(217, 217, 214, 0.6)',
    lighter: 'rgba(217, 217, 214, 0.8)'
  },
  text: {
    darker: '#000000',
    dark: '#707479',
    base: '#101820',
    light: '#CCCECF',
    lighter: '#FFFFFF'
  }
};
export default _extends({}, colors, {
  typography: {
    textColor: colors.secondary.base,
    disabledTextColor: colors.secondary.light
  }
});